<template>
    <v-container 
        fluid 
        px-0 
        mt-0>
        <v-card>
            <v-card-title>
                <v-row 
                    no-gutters 
                    align="start" 
                    justify="space-between">
                    <v-col sm="auto">
                        <div class="title">
                            Externo | Solicitud de servicio
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="mt-5">
                <div v-if="loading">
                    <v-layout wrap>
                        <v-col 
                            v-for="i in [1, 2, 3]" 
                            :key="'sl_pssc_' + i" 
                            cols="12">
                            <v-skeleton-loader 
                                ref="skeleton" 
                                type="image" 
                                class="mx-auto" />
                        </v-col>
                    </v-layout>
                </div>
                <div v-else-if="valido && !loading">
                    <v-layout>
                        <v-flex 
                            sm12 
                            md6 
                            offset-md3>
                            <ficha-servicio
                                :id-servicio="idServicio"
                                :clave-servicio="claveServicio"
                            />
                        </v-flex>
                    </v-layout>
                    <ficha-requisitos
                        :id-servicio="idServicio"
                        :clave-servicio="claveServicio"
                        :id-estatus="idEstatus"
                    />
                </div>
                <v-alert 
                    v-else 
                    type="warning">
                    Ocurrió un problema al consultar el servicio.
                </v-alert>
                <br >
            </v-card-text>
        </v-card>

        <v-snackbar
            key="snackbar_plantillasolicitudservicio"
            v-model="snackbarError"
            :bottom="true"
            :multi-line="true"
            color="error"
        >
            {{ textoError }}
            <v-btn 
                dark 
                text 
                @click="snackbarError = false">
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { getValidacionServicioExterno } from "@/api";

export default {
  name: "PlantillaSolicitudServicio",
  components: {
    FichaServicio: () => import("../../components/molecules/FichaServicio"),
    FichaRequisitos: () => import("../../components/molecules/FichaRequisitos")
  },
  props: {
    idServicio: {
      type: String,
      required: true
    },
    claveServicio: {
      type: String,
      required: true
    },
    idEstatus: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      valido: false,
      snackbarError: false,
      textoError: ""
    };
  },
  computed: {},
  mounted () {
    this.getValidacionServicioExterno_();
  },
  methods: {
    async getValidacionServicioExterno_ () {
      var self = this;
      self.loading = true;
      self.valido = false;

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getValidacionServicioExterno(
          self.idServicio,
          self.claveServicio
        );

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.valido = true;
              self.loading = false;
            } else {
              self.loading = false;
              self.valido = false;
            }
          } else {
            self.loading = false;
            self.valido = false;

            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.loading = false;
          self.valido = false;

          self.snackbarError = true;
          self.textoError = "Error de red";
        }
      } catch (e) {
        self.loading = false;
        self.valido = false;

        self.snackbarError = true;
        self.textoError = e;
      }
    }
  }
};
</script>
